import { Transaction } from '../../../shared/types';
import { Flex, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CellProps } from '../../../shared/components/NewTable/useColumns';
import { BetaIcon } from '../../../../lib/components';

export const StatusButton = ({ row }: CellProps<Transaction>) => {
  const { t } = useTranslation();

  const errors = row?.dds?.errors?.join(', ').replace(/([-A-Z]+: )+/g, '');

  if (row?.status === 'ERROR') {
    return (
      <Tooltip label={errors} disabled={!errors} multiline maw={200}>
        <Flex gap={4} align="center" data-testid="status">
          <BetaIcon icon="circle-info" size="sm" color="red.2" />
          <Text c="red.2">{t(`transactions.status.${row.status}`)}</Text>
        </Flex>
      </Tooltip>
    );
  }

  return <Text>{t(`transactions.status.${row.status}`)}</Text>;
};
